import { render, staticRenderFns } from "./informacion_admin.vue?vue&type=template&id=6743a243&scoped=true&"
import script from "./informacion_admin.vue?vue&type=script&lang=js&"
export * from "./informacion_admin.vue?vue&type=script&lang=js&"
import style0 from "./informacion_admin.vue?vue&type=style&index=0&id=6743a243&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6743a243",
  null
  
)

export default component.exports